import { render } from "./consumption_records.vue?vue&type=template&id=1b2c993a&scoped=true"
import script from "./consumption_records.vue?vue&type=script&lang=js"
export * from "./consumption_records.vue?vue&type=script&lang=js"

import "./consumption_records.vue?vue&type=style&index=0&id=1b2c993a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2c993a"],['__file',"src/views/account_center/components/consumption_records.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b2c993a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b2c993a', __exports__)) {
    api.reload('1b2c993a', __exports__)
  }
  
  module.hot.accept("./consumption_records.vue?vue&type=template&id=1b2c993a&scoped=true", () => {
    api.rerender('1b2c993a', render)
  })

}


export default __exports__